<template>
  <div>
    <div style="margin-left:30px;font-weight: bold;font-size: 30px;">请选择进入的公司：</div>
    <div v-for="(item,index) in itemCompanyList" :key="index">
      <div>
        <el-card>
          <div slot="header">
            <span style="font-size: 20pt; color: #004768">公司信息-公司{{ item.companyId }}</span>
          </div>
          <div class="container2">
            <el-row >
              <div class="info-title">公司名称：</div>
              <div class="info-content">{{ item.companyName }}</div>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-button  :ripple="true" ripple-bg-color="#aaff00"
                         :round="true" :plain="true" size="mini" @click="gointo(item)">
                <i class="el-icon-view"/>
                <span style="font-size: 15px; font-weight: 400; font-style: normal; ">进入</span>
              </el-button>

            </el-row>
          </div>
        </el-card>
      </div>
    </div>

  </div>

</template>

<script>
import API from "../../../config/api";
// const IMGURL = require("../../../config/imgUrl")
export default {
  data() {
    return {
      itemCompanyList: [], //有权限查看的公司列表
      canReadId: null, //有权限查看的公司页面
      companyId: '',
      userId: '',
      // logoImg: IMGURL.logoImgUrl, //logo图片
      // logoHome: IMGURL.logoHome,
      // logoCompany: IMGURL.logoCompany,

    }
  },
  mounted() {
    let isApp = parseInt(this.$route.query.isApp);
    if(isApp===1){
      let userId = parseInt(this.$route.query.userId);
      let token = this.$route.query.token;
      window.localStorage.setItem('userid',userId);
      window.localStorage.setItem('token',token);
      window.localStorage.setItem('isApp',1);
    }
    // 获取该用户有权限查看的公司
    this.getPermissionCompanyList();
    this.userId = window.localStorage.getItem('userid');
    console.log('公司列表userId的值=', this.userId);
  },

  methods: {
    getPermissionCompanyList() {
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {}
      this.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.itemCompanyList = res.data["companyList"];
          if (this.itemCompanyList.length == 0){
            if(window.localStorage.getItem('isApp') == '1'){
              //这里要改成app没公司不管是开发者还是普通用户就跳转到默认界面
              self.$router.push({path: '/pages/redirect/defaultCreate'})
            }else{
              self.$router.push({path: '/pages/userCenter/UserCenter'})
            }
          }

        }
      });
    },

    //进入公司看项目
    gointo(item) {
      this.companyId = item.companyId;
      window.localStorage.setItem("companyId", item.companyId);
      window.localStorage.setItem("companyRoleType", item.role_type);
      window.localStorage.setItem("companyName",item.companyName);
      if (item.role_type == 0) {
        if(window.localStorage.getItem('isApp') == '1'){
          //手机端 开发者进入后不进入开发页面 看公司里面有没有被授权的页面
          console.log('wokankan')
          this.getProductUserList(item)
        }else{
          console.log('shiwoshiwoshiwo1')
          this.$router.push({path: '/pages/MainOperatePage', query: {companyId: item.companyId}})
        }
      }
      if (item.role_type == 1) {
        this.getProductUserList(item)
      }
    },
    //获取用户已有的界面权限
    getProductUserList(item) {
      let self = this;
      //加一个接口通过userId获取到已经添加权限页面的名字,后端需要加开发者也可以授权界面
      let header1 = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data1 = {
        companyId: item.companyId,
        productUserId: this.userId, //登陆者自身
      }

      this.$axiosRequest({
        url: API.getProductUserList,
        method: 'POST',
        data: data1,
        header: header1,
        success: res => {
          console.log(res)
          let userCanRead = res.data["productUserList"];
          if (userCanRead.length != 0)
            this.canReadId = userCanRead[0].productId;
          if (userCanRead.length == 0)
            this.canReadId = null;
          if (this.canReadId != null) {
            self.$router.push({
              path: '/pages/redirect/create',
              query: {companyId: item.companyId, editType: "3", productId: self.canReadId}
            })
          }
          if (this.canReadId == null) {
            console.log(this.canReadId)
            self.$message({type: 'success', message: '暂无分配的主页面'});
            if(window.localStorage.getItem('isApp') == '1'){
              //这里写统一到默认页面
              self.$router.push({path: '/pages/redirect/defaultCreate'})
            }else{
              self.$router.push({path: '/pages/userCenter/UserCenter'})
            }
          }

        }
      });

    }

  },
}
</script>

<style lang="less">
swiper {
  height: 400px;

  image {
    width: 100%;
  }
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
  display:inline-block;
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  display:inline-block;
  // font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
  background-color: rgba(240, 240, 240, 0.7);
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  //font-weight: bold;
  line-height: 40px;
}

.title3-style {
  font-size: 12px;
  line-height: 40px;
  color: gray
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  background-color: rgba(240, 240, 240, 0.5);
  padding: 24px;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}
</style>
